import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { FormField } from '../../../../../../components/FormFields';
import { Loader } from '../../../../../../components/Loader';
import { VehicleCreateFieldCompany } from '../../../../pages/create/FieldCompany';
import { initiateNewVehicleValue, setNewVehicleValue } from '../../../../actions';
import { selectNewVehicle, selectNewVehicleValue } from '../../../../selectors';
import { selectWork } from '../../../../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../../constants';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { HBox } from '../../../../../../components/Box';
import { Button } from '../../../../../../components/Buttons';
import { initiateNewInvoiceValue, setNewInvoiceValue } from '../../../../../Invoices/actions';
import { selectNewInvoiceValue } from '../../../../../Invoices/selectors';
import cn from 'classnames';
import ButtonComponent from '../../../../../../containers/App/Components/Button/Button';
import styles from './Fields.module.css';

dayjs.extend(customParseFormat);

const Container = styled.div`
  width: 100%;
  margin-bottom: 8px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .rightDecorationBlock {
    width: 100px;
    display: flex;

    .deleteBtn {
      background-color: #d50046;
    }
  }
`;

const STATE = {
  value: '',
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreditorFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();
  }

  addNewCompany() {
    this.props.showNewCompanyModal();
  }

  wrap(children) {
    switch (this.props.type) {
      default:
        return (
          <div>
            <label className={cn('form-label', this.props.className)}>{this.formFieldLabel()}</label>
            {children}
          </div>
        );
    }
  }

  formFieldLabel() {
    return this.lbl(`vehicle.property.${this.props.type}`);
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;

    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  renderField() {
    if (this.props.value === undefined) return null;

    switch (this.props.type) {
      case 'creditor_company':
        return (
          <>
            {!this.props.tradeInVehicle ? (
              <>
                <VehicleCreateFieldCompany
                  customerNumberSearch
                  title={this.props.type}
                  key={this.props.type}
                  type={this.props.type}
                  onChange={value => this.props.setValue(value)}
                />
                <div className="mt-2">
                  <Button style={'ButtonSoftPrimary'} onClick={this.addNewCompany.bind(this)}>
                    {this.lbl('new_customer')}
                  </Button>
                </div>
              </>
            ) : (
              <>
                <VehicleCreateFieldCompany
                  customerNumberSearch
                  tradeInVehicle
                  title={this.props.type}
                  key={this.props.type}
                  type={this.props.type}
                  onChange={value => this.props.setValue(value)}
                />
              </>
            )}
          </>
        );
    }
  }
}

VehicleCreditorFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    value: ownProps.invoicePage ? selectNewInvoiceValue(ownProps.type) : selectNewVehicleValue(ownProps.type),
    values: selectNewVehicle(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      ownProps.invoicePage ? dispatch(setNewInvoiceValue(name, value)) : dispatch(setNewVehicleValue(name, value));
    },
    initiateValue() {
      ownProps.invoicePage
        ? dispatch(initiateNewInvoiceValue(ownProps.type))
        : dispatch(initiateNewVehicleValue(ownProps.type));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreditorField = compose(withConnect, withRouter)(VehicleCreditorFieldComp);
